
import React, { useState } from "react";

const productImages = [
  "/products/towelsquare.png",
  "/products/towelstacked.png",
  "/products/towellong.png",
  "/products/towelcorner.png",
  "/products/towelround.png",
  "/products/towel2layer.png",
  "/products/bag.png",
];

const ProductLinePage = () => {
  const [selectedImage, setSelectedImage] = useState(productImages[0]);

  return (
    <main
      style={{
        backgroundColor: "#000",
        color: "#fff",
        minHeight: "auto",
        padding: "clamp(30px, 5vw, 80px) 20px 40px",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <header
  style={{
    textAlign: "center",
    marginBottom: "clamp(20px, 5vw, 60px)",
  }}
>
          <h1
            style={{
              fontSize: "clamp(32px, 5vw, 56px)",
              fontWeight: 600,
              letterSpacing: "2px",
              marginBottom: "20px",
            }}
          >
            ELEMENT 78 PRODUCT LINE
          </h1>
          <p style={{ color: "#aaa", fontSize: "18px" }}>
            Professional-grade detailing products designed to deliver
            exceptional results.
          </p>
        </header>

        <section
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 360px), 1fr))",
            gap: "48px",
            alignItems: "start",
            border: "1px solid #333",
            borderRadius: "14px",
            padding: "clamp(20px, 4vw, 40px)",
          }}
        >
          {/* PRODUCT GALLERY */}
          <div style={{ minWidth: 0 }}>
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <img
                src={selectedImage}
                alt="Element 78 Premium Twisted-Loop Drying Towel"
                style={{
  display: "block",
  width: "100%",
  aspectRatio: "4 / 3",
  objectFit: "cover",
}}
              />
            </div>

            <div
             style={{
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: "10px",
  marginTop: "15px",
  justifyContent: "start",
  maxWidth: "100%",
}}
            >
              {productImages.map((image, index) => (
                <button
                  key={image}
                  type="button"
                  onClick={() => setSelectedImage(image)}
                  aria-label={`View product photo ${index + 1}`}
                  aria-pressed={selectedImage === image}
                  style={{
  padding: 0,
  width: "100%",
aspectRatio: "1 / 1",
  border:
    selectedImage === image
      ? "2px solid #8b5cf6"
      : "2px solid #333",
  borderRadius: "8px",
  overflow: "hidden",
  background: "#fff",
  cursor: "pointer",
}}
                >
                  <img
                    src={image}
                    alt={`Drying towel view ${index + 1}`}
                    style={{
                      width: "100%",
                      aspectRatio: "1 / 1",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* PRODUCT DETAILS */}
          <div style={{ minWidth: 0 }}>
            <h2
              style={{
                fontSize: "clamp(26px, 3vw, 38px)",
                lineHeight: 1.2,
                marginBottom: "20px",
              }}
            >
              Premium Twisted-Loop Drying Towel
            </h2>

            <p
              style={{
                color: "#bbb",
                fontSize: "17px",
                marginBottom: "28px",
              }}
            >
              Engineered for superior water absorption and gentle vehicle
              drying.
            </p>

            <div
              style={{
                borderTop: "1px solid #333",
                borderBottom: "1px solid #333",
                padding: "22px 0",
                marginBottom: "28px",
                lineHeight: 2,
              }}
            >
              <p><strong>Material:</strong> Premium Microfiber</p>
              <p><strong>Construction:</strong> Twisted-Loop</p>
              <p><strong>Density:</strong> 1400 GSM</p>
              <p><strong>Size:</strong> 20" × 31.5" (50 × 80 cm)</p>
              <p><strong>Color:</strong> Purple &amp; Black</p>
            </div>

            <h3 style={{ fontSize: "21px", marginBottom: "14px" }}>
              Designed for a Better Dry
            </h3>

            <p
              style={{
                color: "#aaa",
                lineHeight: 1.8,
                marginBottom: "30px",
              }}
            >
              Our premium twisted-loop microfiber towel is designed to
              absorb water efficiently while providing a soft touch
              on vehicle surfaces. Ideal for enthusiasts and
              professional detailers alike.
            </p>

            <div
  style={{
    padding: "20px",
    border: "1px solid #333",
    borderRadius: "10px",
  }}
>
  <p style={{ color: "#aaa", marginBottom: "16px" }}>
    Available through our online store
  </p>

  <a
    href="https://app.urable.com/virtual-shop/nm5qG9H2g5ahH4Xkm9TN/YsPnEoy1QRADTuzGQOw6"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-block",
      backgroundColor: "#fff",
      color: "#000",
      padding: "14px 36px",
      borderRadius: "8px",
      fontSize: "16px",
      fontWeight: "700",
      textDecoration: "none",
      textAlign: "center",
      letterSpacing: "1px",
    }}
  >
        BUY NOW
  </a>
</div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default ProductLinePage;
